import { FullHeightCalculatorHOC, HoloHelmet } from 'common-js/components';
import LandingPageEmpty from 'common-js/components/LandingPageEmpty';

const WelcomeWrapper: React.FC = () => (
  <FullHeightCalculatorHOC accountForDrawer backgroundColor="var(--dds-color-palette-grey-10)">
    <HoloHelmet title="Home" />
    <LandingPageEmpty />
  </FullHeightCalculatorHOC>
);

export default WelcomeWrapper;
